/**
 * Ambient era-music manifest for Cinema Mode.
 * All tracks by Kevin MacLeod (incompetech.com), CC-BY 3.0 — free for commercial use with attribution.
 * Files ship in /app/frontend/public/audio/ (served at /audio/{filename}).
 *
 * When we upgrade to Artlist, only this file needs to change — the CinemaMode player is agnostic.
 */
export const AMBIENT_TRACKS = [
  {
    minYear: 1900,
    maxYear: 1949,
    file: "/audio/era_pre1950.mp3",
    title: "Divertimento K131",
    attribution: "Kevin MacLeod (incompetech.com) — CC BY 3.0",
  },
  {
    minYear: 1950,
    maxYear: 1959,
    file: "/audio/era_1950s.mp3",
    title: "Cambodian Odyssey",
    attribution: "Kevin MacLeod (incompetech.com) — CC BY 3.0",
  },
  {
    minYear: 1960,
    maxYear: 1969,
    file: "/audio/era_1960s.mp3",
    title: "Vibe Ace",
    attribution: "Kevin MacLeod (incompetech.com) — CC BY 3.0",
  },
  {
    minYear: 1970,
    maxYear: 1979,
    file: "/audio/era_1970s.mp3",
    title: "Funk Game Loop",
    attribution: "Kevin MacLeod (incompetech.com) — CC BY 3.0",
  },
  {
    minYear: 1980,
    maxYear: 2999,
    file: "/audio/era_1980s_plus.mp3",
    title: "Groove Grove",
    attribution: "Kevin MacLeod (incompetech.com) — CC BY 3.0",
  },
];

export function pickAmbientTrack(year) {
  const y = parseInt(year, 10);
  if (isNaN(y)) return AMBIENT_TRACKS[0];
  const hit = AMBIENT_TRACKS.find((t) => y >= t.minYear && y <= t.maxYear);
  return hit || AMBIENT_TRACKS[AMBIENT_TRACKS.length - 1];
}
